import type { CustomIconProps } from '../types';

const EmptyRoundedStar = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '45'}
        height={height ?? '45'}
        viewBox="0 0 45 45"
        fill="none"
    >
        <path
            d="M15.5786 15.2805L15.844 15.242L15.9587 14.9995L22.5 1.16942L29.0413 14.9995L29.156 15.242L29.4214 15.2805L43.9584 17.3898L33.3915 28.2586L33.2152 28.44L33.2568 28.6895L35.8232 44.0631L22.7415 36.8479L22.4973 36.7132L22.2544 36.8502L9.46214 44.0626L11.7446 28.6805L11.7809 28.4359L11.6085 28.2586L1.04162 17.3898L15.5786 15.2805Z"
            fill="white"
            stroke="#414042"
        />
    </svg>
);

export default EmptyRoundedStar;
